import { Card, PageContainer } from '@shared';
import { OrganizationStep } from '@/features/registration/OrganizationStep';
import { RegistrationProvider } from '@/features/registration/RegistrationProvider';
import { useTranslations } from '@/i18n/client';
import type { OrganizationApi } from '@/services/api/organization-api';

export interface OrganizationPageProps {
  /** Test-only injection point for a mock OrganizationApi. */
  organization?: OrganizationApi;
}

/**
 * Protected step-2 page: enter mandatory company info to complete MDenture registration.
 * Reached after e-mail confirmation established an authenticated JWT session.
 */
export function OrganizationPage({ organization }: OrganizationPageProps) {
  const t = useTranslations('registration');

  return (
    <PageContainer className="md-auth md-organization-page flex min-h-full items-start justify-center px-6 py-12 max-sm:w-full max-sm:px-0 max-sm:py-4">
      <Card
        title={t('page.orgTitle')}
        className="max-sm:box-border max-sm:w-full max-sm:p-4 max-sm:[&_p]:wrap-anywhere"
      >
        <p className="md-auth__subtitle">{t('page.orgSubtitle')}</p>
        <RegistrationProvider organization={organization}>
          <OrganizationStep />
        </RegistrationProvider>
      </Card>
    </PageContainer>
  );
}
